
import React from 'react'
import { MuiIconButton, MuiCancel, MuiGrid, MuiTypography, MuiDialog } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({

    root: { border: '1px solid' + theme.palette.primary.main },
    mainGrid: { border: "4px solid" + theme.palette.primary.main, boxSizing: 'border-box', paddingLeft: 16, paddingBottom: 16, paddingRight: 24 },
    titleGrid: { boxSizing: 'border-box', paddingBottom: 4, paddingTop: 8 },
    gridStyle: { boxSizing: 'border-box', padding: 16, border: "1px solid" + theme.palette.primary.main },
    tableStyle: { border: "1px solid" + theme.palette.primary.main },
    tableRowStyle: { borderRight: "1px solid" + theme.palette.primary.main },
    tableCellStyle: { boxSizing: 'border-box', padding: 8 }
}));

function ScheduleSummaryDialog(props) {
    const classes = useStyles();
    const { i18n } = props
    const toggleShowMethod=async()=>{
await props.toggleShowMethod();
    }
    return (

        <MuiDialog
            fullWidth={true}
            disableBackdropClick={true}
            open={props.open} className={classes.root}
            // onClick={() => props.toggleShowMethod()}
            //  aria-labelledby="customized-dialog-title"
             >
            <MuiGrid xs={12} className={classes.mainGrid} >
                <MuiGrid container xs={12} justify='space-between' className={classes.titleGrid}>
                    <MuiGrid xs >
                        <MuiTypography variant={theme.typographyStyles.H6} color="primary"> <b>{i18n.schedule.timeTable} - {props.schedule.name}</b></MuiTypography>
                    </MuiGrid>   <MuiGrid >
                        <MuiIconButton aria-label="close" color='primary' onClick={toggleShowMethod}>
                            <MuiCancel />
                        </MuiIconButton>
                    </MuiGrid>
                </MuiGrid>
                {/* <MuiGrid container xs={12} style={{
                    boxSizing: 'border-box', paddingBottom: 4,
                }} justify='flex-end'>
                    button
                </MuiGrid> */}
                <MuiGrid container xs={12} className={classes.gridStyle}>
                    <MuiGrid container xs={12} className={classes.tableStyle}>
                        {props.schedule.timeTableSummary.map((summary, index) =>
                            <MuiGrid container xs={12} style={{ borderBottom: (index + 1 == props.schedule.timeTableSummary.length) ? '' : "1px solid" + theme.palette.primary.main }}>
                                <MuiGrid container xs={9} className={classes.tableRowStyle}>
                                    <MuiTypography variant={theme.typographyStyles.BODY} className={classes.tableCellStyle}>
                                        {summary.messageItem.message}</MuiTypography>

                                </MuiGrid>
                                <MuiGrid container xs={3} >
                                    <MuiTypography variant={theme.typographyStyles.BODY} className={classes.tableCellStyle}>

                                        {summary.messageItem.value}
                                    </MuiTypography>
                                </MuiGrid>
                            </MuiGrid>
                        )}
                    </MuiGrid>
                </MuiGrid>
            </MuiGrid>
        </MuiDialog>
    )


}

export default (ScheduleSummaryDialog);